/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PredictCategoryRequest
 */
export interface PredictCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof PredictCategoryRequest
     */
    headline: string;
    /**
     * 
     * @type {string}
     * @memberof PredictCategoryRequest
     */
    vertical?: PredictCategoryRequestVerticalEnum;
}


/**
 * @export
 */
export const PredictCategoryRequestVerticalEnum = {
    Freelancer: 'FREELANCER',
    Strategy: 'STRATEGY'
} as const;
export type PredictCategoryRequestVerticalEnum = typeof PredictCategoryRequestVerticalEnum[keyof typeof PredictCategoryRequestVerticalEnum];


/**
 * Check if a given object implements the PredictCategoryRequest interface.
 */
export function instanceOfPredictCategoryRequest(value: object): value is PredictCategoryRequest {
    if (!('headline' in value) || value['headline'] === undefined) return false;
    return true;
}

export function PredictCategoryRequestFromJSON(json: any): PredictCategoryRequest {
    return PredictCategoryRequestFromJSONTyped(json, false);
}

export function PredictCategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictCategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'headline': json['headline'],
        'vertical': json['vertical'] == null ? undefined : json['vertical'],
    };
}

export function PredictCategoryRequestToJSON(value?: PredictCategoryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'headline': value['headline'],
        'vertical': value['vertical'],
    };
}

